/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 会社設定一覧レスポンス
 * @export
 * @interface ListCompanies200ResponseItemsInner
 */
export interface ListCompanies200ResponseItemsInner {
    /**
     * グループ名
     * @type {string}
     * @memberof ListCompanies200ResponseItemsInner
     */
    groupName: string;
    /**
     * 会社名
     * @type {string}
     * @memberof ListCompanies200ResponseItemsInner
     */
    companyName: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof ListCompanies200ResponseItemsInner
     */
    companyId: string;
    /**
     * PG名
     * @type {string}
     * @memberof ListCompanies200ResponseItemsInner
     */
    paymentGroupName?: string;
    /**
     * サービス名
     * @type {string}
     * @memberof ListCompanies200ResponseItemsInner
     */
    serviceName?: string;
    /**
     * 費目名
     * @type {string}
     * @memberof ListCompanies200ResponseItemsInner
     */
    expenseItemName?: string;
    /**
     * 集計期間区分 1=1日〜月末 2=A: 1日〜15日,B: 16日〜月末
     * @type {number}
     * @memberof ListCompanies200ResponseItemsInner
     */
    aggregationPeriodKind?: ListCompanies200ResponseItemsInnerAggregationPeriodKindEnum | null;
    /**
     * 精算処理日区分 1=翌月1日 2=A: 当月16日,B: 翌月1日
     * @type {number}
     * @memberof ListCompanies200ResponseItemsInner
     */
    processingPeriodKind?: ListCompanies200ResponseItemsInnerProcessingPeriodKindEnum | null;
}


/**
 * @export
 */
export const ListCompanies200ResponseItemsInnerAggregationPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type ListCompanies200ResponseItemsInnerAggregationPeriodKindEnum = typeof ListCompanies200ResponseItemsInnerAggregationPeriodKindEnum[keyof typeof ListCompanies200ResponseItemsInnerAggregationPeriodKindEnum];

/**
 * @export
 */
export const ListCompanies200ResponseItemsInnerProcessingPeriodKindEnum = {
    ONCE_MONTH: 1,
    TWICE_MONTH: 2
} as const;
export type ListCompanies200ResponseItemsInnerProcessingPeriodKindEnum = typeof ListCompanies200ResponseItemsInnerProcessingPeriodKindEnum[keyof typeof ListCompanies200ResponseItemsInnerProcessingPeriodKindEnum];


/**
 * Check if a given object implements the ListCompanies200ResponseItemsInner interface.
 */
export function instanceOfListCompanies200ResponseItemsInner(value: object): value is ListCompanies200ResponseItemsInner {
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function ListCompanies200ResponseItemsInnerFromJSON(json: any): ListCompanies200ResponseItemsInner {
    return ListCompanies200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListCompanies200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCompanies200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'groupName': json['group_name'],
        'companyName': json['company_name'],
        'companyId': json['company_id'],
        'paymentGroupName': json['payment_group_name'] == null ? undefined : json['payment_group_name'],
        'serviceName': json['service_name'] == null ? undefined : json['service_name'],
        'expenseItemName': json['expense_item_name'] == null ? undefined : json['expense_item_name'],
        'aggregationPeriodKind': json['aggregation_period_kind'] == null ? undefined : json['aggregation_period_kind'],
        'processingPeriodKind': json['processing_period_kind'] == null ? undefined : json['processing_period_kind'],
    };
}

export function ListCompanies200ResponseItemsInnerToJSON(json: any): ListCompanies200ResponseItemsInner {
    return ListCompanies200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListCompanies200ResponseItemsInnerToJSONTyped(value?: ListCompanies200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_name': value['groupName'],
        'company_name': value['companyName'],
        'company_id': value['companyId'],
        'payment_group_name': value['paymentGroupName'],
        'service_name': value['serviceName'],
        'expense_item_name': value['expenseItemName'],
        'aggregation_period_kind': value['aggregationPeriodKind'],
        'processing_period_kind': value['processingPeriodKind'],
    };
}

